package dev.lingvo.site.components.studio.preview

import dev.lingvo.shared.DeviceClass
import dev.lingvo.shared.screenshots.doc.BrandKit
import dev.lingvo.shared.screenshots.doc.FrameKind
import dev.lingvo.shared.screenshots.doc.Palette
import dev.lingvo.shared.screenshots.templates.Template
import dev.lingvo.shared.screenshots.text.Script

/** Coverage stays visible next to a font choice, so Latin faces are never advertised as universal. */
data class FontChoice(val name: String, val scripts: Set<Script>)

/** The pure facet of the single looks seam lets immutable edits run independently of browser resources. */
interface DesignCatalogPort {
    /** An unavailable catalog is explicit; existing documents can still be reviewed. */
    val available: Boolean
    /** Launch layouts remain ordered by the catalog. */
    fun layouts(): List<Template>
    /** The gallery uses the same catalog as the inline picker. */
    fun templates(): List<Template>
    /** Semantic colours come from the template owner, never a second site implementation. */
    fun palette(template: Template, brand: BrandKit): Palette
    /** Pixel analysis never sends the project icon to another service. */
    fun iconPalette(rgba: IntArray, w: Int, h: Int): List<String>
    /** Only compatible silhouettes reach the picker. */
    fun framesFor(device: DeviceClass): List<FrameKind>
    /** Initial geometry follows the engine's device rules. */
    fun defaultFrame(device: DeviceClass): FrameKind
    /** The engine allowlist also defines selectable font coverage. */
    fun fontFamilies(): List<FontChoice>
}
